import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AuthService } from '@common/services/auth.service';
import { infoItems } from '../info/info.component';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { InMemoryQueryService } from '@common/services/inmemory.query.service';
import { PhaseJpService } from '@lang/jp/services/phasejp.service';
import { EnjpCommunityService } from '../../services/community.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
    @ViewChildren(NgbDropdown) dropdowns!: QueryList<NgbDropdown>;

    showMenu = true;
    showMenuLinks = true;
    regex = /\/|\?|\#/;
    navbarCollapsed = true;
    appendText = '';
    items = [
        {
            link: '/home',
            cmsKey: 'main-menu-home',
            id: 'menu-button-home',
            children: null,
        },
        {
            link: '/info',
            cmsKey: 'main-menu-info',
            id: 'menu-button-info',
            children: infoItems
                .filter(
                    (item) =>
                        !item.communityCodes ||
                        item.communityCodes.includes(
                            this.communityService.communityCode,
                        ),
                )
                .map((infoItem) => {
                    return {
                        link: '/info/' + infoItem.id,
                        cmsKey: 'info-item-' + infoItem.id + '-header',
                        id: infoItem.id,
                    };
                }),
        },
        {
            link: '/register',
            cmsKey:
                'main-menu-' +
                this.phaseService.getCmsAppendStringStatic +
                'register',
            id: 'menu-button-register',
            children: null,
        },
        {
            link: '/suppliers',
            cmsKey: 'main-menu-suppliers',
            id: 'menu-button-suppliers',
        },
        {
            link: '/faq',
            cmsKey: 'main-menu-faq',
            id: 'menu-button-faq',
            children: null,
        },
        {
            link: '/contact',
            cmsKey: 'main-menu-contact',
            id: 'menu-button-contact',
            children: null,
        },
    ];

    get communityIsValid() {
        return this.communityService.communityIsValid;
    }
    get communityCode() {
        return this.communityService.communityCode;
    }

    get page() {
        return window.location.pathname.split(this.regex)[3];
    }

    constructor(
        public communityService: EnjpCommunityService,
        public authService: AuthService,
        private queryService: InMemoryQueryService,
        private phaseService: PhaseJpService,
    ) {}

    moreInfoDropdownClick() {
        this.navbarCollapsed = true;
        this.dropdowns.forEach((dropdown) => dropdown.close());
    }

    ngOnInit(): void {
        this.queryService.getObservable$('app-menu').subscribe((e) => {
            if (e.name === 'showMenu' && e.value !== null) {
                this.showMenu = e.value;
            } else if (e.name === 'showMenuLinks' && e.value !== null) {
                this.showMenuLinks = e.value;
            }
        });

        this.communityService.isCommunityRegistrationEnabled$.subscribe(
            (isEnabled) => {
                if (!isEnabled) {
                    this.items = this.items.filter(
                        (i) => i.link !== '/register',
                    );
                }
            },
        );
    }
}
